<template>
  <div class="widget_page_path">
    <div
      class="path"
      v-for="(item, index) in paths"
      :key="index"
      :class="{ active: index == paths.length - 1 }"
      @click="selectPath(item, index)"
    >
      <span>{{ item.label }}</span>
      <div v-if="index < paths.length - 1" class="path-divider">/</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "widget_page_path",
  props: {
    paths: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  watch: {},
  mounted() {},
  methods: {
    selectPath(item, index) {
      let vm = this;
      if (index < vm.paths.length - 1) {
        vm.$router.push({ path: item.path });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.widget_page_path {
  display: flex;
  align-items: center;
  .path {
    display: flex;
    align-items: center;
    cursor: pointer;
    span {
      color: #8b98b8;
    }
    .path-divider {
      margin: 0px 10px;
      color: #8b98b8;
    }
    &:hover {
      span {
        color: #0f2f64;
      }
      .path-divider {
        margin: 0px 10px;
        color: #0f2f64;
      }
    }
    &.active {
      span {
        color: #0f2f64;
      }
      .path-divider {
        margin: 0px 10px;
        color: #0f2f64;
      }
    }
  }
}
</style>
